import { lazy } from 'react';

// project imports
import MainLayout from 'jsx/layout/MainLayout';
import Loadable from 'jsx/components/utilities/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// employee routes
const Dashboard = Loadable(lazy(() => import('jsx/views/admin/Dashboard/Dashbord1')));
const Dashboard2 = Loadable(lazy(() => import('jsx/views/admin/Dashboard/DashBoard2')));
const Dashboard3 = Loadable(lazy(() => import('jsx/views/admin/Dashboard/DashBoard3')));
const Organization = Loadable(lazy(() => import('jsx/views/admin/Organization')));
const ChartedAccount = Loadable(lazy(() => import('jsx/views/admin/ChartedAcount')));
const EmployeeList = Loadable(lazy(() => import('jsx/views/admin/Organization/EmployeeList')));
const AdminUsers = Loadable(lazy(() => import('jsx/views/admin/AdminUsers')));
const SupportTickets = Loadable(lazy(() => import('jsx/views/admin/SupportTickets')));
const DemoRequests = Loadable(lazy(() => import('jsx/views/admin/DemoRequests')));
const CompanySettings = Loadable(lazy(() => import('jsx/views/admin/Organization/CompanySettings')));
const EmployeeDetails = Loadable(lazy(() => import('jsx/views/admin/Organization/employee-details')));

const EmployeeRoutes = {
    path: '/admin',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'dashboard-2', element: <Dashboard2 /> },
        { path: 'charted-account', element: <ChartedAccount /> },
        { path: 'dashboard-3', element: <Dashboard3 /> },
        { path: 'organization', element: <Organization /> },
        { path: 'organization/create', element: <CompanySettings /> },
        { path: 'organization/:company_uuid/edit', element: <CompanySettings /> },
        { path: 'organization/:company_uuid/employee', element: <EmployeeList /> },
        { path: 'organization/:company_uuid/employee/:employee_uuid', element: <EmployeeDetails /> },
        { path: 'users', element: <AdminUsers /> },
        { path: 'support-tickets', element: <SupportTickets /> },
        { path: 'demo-requests', element: <DemoRequests /> },
    ]
};

export default EmployeeRoutes;
